import { useTranslation } from "react-i18next";
import { useMutation } from "react-query";

import { getDealersRegistryReport } from "~/pages/Dealers/Request/GetDealersRegistryReport";
import { useNotify } from "~/shared/hooks/useNotify";

export default function useGetDealersRegistryReport() {
  const { t } = useTranslation();
  const { notifyReport, notifyError } = useNotify();

  return useMutation({
    mutationFn: getDealersRegistryReport,
    onSuccess: ({ fileHash }) => {
      notifyReport(fileHash);
    },
    onError: () => {
      notifyError(t("common.errorWeb"));
    },
  });
}
